// document.addEventListener("DOMContentLoaded", function () {
//   function updateWishlistCounter() {
//     let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//     document.querySelector(".wishlist-counter").textContent = wishlist.length;
//   }

//   function loadWishlistState() {
//     let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

//     document.querySelectorAll(".wishlist-btn").forEach((btn) => {
//       let productId = btn.getAttribute("data-product-id");
//       let wishlistItem = wishlist.find((item) => item.id === productId);
//       let icon = btn.querySelector(".wishlist-icon");
//       let text = btn.querySelector(".wishlist-text");

//       if (wishlistItem) {
//         text.textContent = "Remove from Wishlist";
//         icon.innerHTML = wishlistItem.iconState; // Load the stored icon
//       } else {
//         text.textContent = "Add to Wishlist";
//         icon.innerHTML = `
//                   <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329ZM10 15.7062C11.6 14.2665 12.9167 13.0325 13.95 12.0042C14.9833 10.976 15.8 10.0827 16.4 9.3244C17 8.56607 17.4167 7.89265 17.65 7.30415C17.8833 6.71582 18 6.13315 18 5.55615C18 4.55615 17.6667 3.72282 17 3.05615C16.3333 2.38949 15.5 2.05615 14.5 2.05615C13.7103 2.05615 12.9805 2.28015 12.3105 2.72815C11.6407 3.17632 11.1102 3.79974 10.7192 4.5984H9.28075C8.88325 3.79324 8.35117 3.16824 7.6845 2.7234C7.01783 2.27857 6.28967 2.05615 5.5 2.05615C4.50633 2.05615 3.67458 2.38949 3.00475 3.05615C2.33492 3.72282 2 4.55615 2 5.55615C2 6.13315 2.11667 6.71582 2.35 7.30415C2.58333 7.89265 3 8.56607 3.6 9.3244C4.2 10.0827 5.01667 10.9744 6.05 11.9994C7.08333 13.0244 8.4 14.26 10 15.7062Z" fill="white"/>
//                   </svg>
//                 `;
//       }
//     });
//   }

//   document.querySelectorAll(".wishlist-btn").forEach((btn) => {
//     btn.addEventListener("click", function () {
//       let productUrl = this.getAttribute("data-product-url");
//       let productId = this.getAttribute("data-product-id");
//       let productTitle = this.getAttribute("data-product-title");
//       let productImage = this.getAttribute("data-product-image");
//       let productPrice = this.getAttribute("data-product-price");
//       let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

//       let wishlistItem = wishlist.find((item) => item.id === productId);
//       let icon = this.querySelector(".wishlist-icon");
//       let text = this.querySelector(".wishlist-text");

//       if (wishlistItem) {
//         wishlist = wishlist.filter((item) => item.id !== productId);
//         text.textContent = "Add to Wishlist";

//         // Show outlined heart when removed
//         let iconHTML = ` 
//                     <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329ZM10 15.7062C11.6 14.2665 12.9167 13.0325 13.95 12.0042C14.9833 10.976 15.8 10.0827 16.4 9.3244C17 8.56607 17.4167 7.89265 17.65 7.30415C17.8833 6.71582 18 6.13315 18 5.55615C18 4.55615 17.6667 3.72282 17 3.05615C16.3333 2.38949 15.5 2.05615 14.5 2.05615C13.7103 2.05615 12.9805 2.28015 12.3105 2.72815C11.6407 3.17632 11.1102 3.79974 10.7192 4.5984H9.28075C8.88325 3.79324 8.35117 3.16824 7.6845 2.7234C7.01783 2.27857 6.28967 2.05615 5.5 2.05615C4.50633 2.05615 3.67458 2.38949 3.00475 3.05615C2.33492 3.72282 2 4.55615 2 5.55615C2 6.13315 2.11667 6.71582 2.35 7.30415C2.58333 7.89265 3 8.56607 3.6 9.3244C4.2 10.0827 5.01667 10.9744 6.05 11.9994C7.08333 13.0244 8.4 14.26 10 15.7062Z" fill="white"/>
//                     </svg>
//                 `;
//         icon.innerHTML = iconHTML;

//         showNotification("Removed from Wishlist", "error");
//       } else {
//         let iconHTML = icon.innerHTML; // Store current icon
//         wishlist.push({
//           id: productId,
//           title: productTitle,
//           image: productImage,
//           price: productPrice,
//           iconState: iconHTML,
//           url: productUrl,
//         });
//         text.textContent = "Remove from Wishlist";

//         // Show filled heart when added
//         icon.innerHTML = `
//                     <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                          <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329Z" fill="white"/>
//                      </svg>
//                 `;

//         showNotification("Added to Wishlist", "success");
//       }

//       localStorage.setItem("wishlist", JSON.stringify(wishlist));
//       updateWishlistCounter();
//     });
//   });

//   function showNotification(message, type) {
//     let notification = document.createElement("div");
//     notification.className = `wishlist-notification ${type}`;
//     notification.innerText = message;
//     document.body.appendChild(notification);
//     setTimeout(() => notification.remove(), 3000);
//   }

//   updateWishlistCounter();
//   loadWishlistState(); // Ensure wishlist state persists after refresh
// });


document.addEventListener("DOMContentLoaded", function () {
  // SVG icon constants for consistency
  const HEART_OUTLINE = `
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329ZM10 15.7062C11.6 14.2665 12.9167 13.0325 13.95 12.0042C14.9833 10.976 15.8 10.0827 16.4 9.3244C17 8.56607 17.4167 7.89265 17.65 7.30415C17.8833 6.71582 18 6.13315 18 5.55615C18 4.55615 17.6667 3.72282 17 3.05615C16.3333 2.38949 15.5 2.05615 14.5 2.05615C13.7103 2.05615 12.9805 2.28015 12.3105 2.72815C11.6407 3.17632 11.1102 3.79974 10.7192 4.5984H9.28075C8.88325 3.79324 8.35117 3.16824 7.6845 2.7234C7.01783 2.27857 6.28967 2.05615 5.5 2.05615C4.50633 2.05615 3.67458 2.38949 3.00475 3.05615C2.33492 3.72282 2 4.55615 2 5.55615C2 6.13315 2.11667 6.71582 2.35 7.30415C2.58333 7.89265 3 8.56607 3.6 9.3244C4.2 10.0827 5.01667 10.9744 6.05 11.9994C7.08333 13.0244 8.4 14.26 10 15.7062Z" fill="white"/>
    </svg>
  `;

  const HEART_FILLED = `
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17.7329L8.89625 16.7407C7.23858 15.2368 5.86775 13.9446 4.78375 12.8639C3.69975 11.7831 2.84075 10.8212 2.20675 9.97815C1.57275 9.13532 1.12983 8.3664 0.878 7.6714C0.626 6.97657 0.5 6.27149 0.5 5.55615C0.5 4.13699 0.9785 2.94882 1.9355 1.99165C2.89267 1.03465 4.08083 0.556152 5.5 0.556152C6.373 0.556152 7.198 0.760319 7.975 1.16865C8.752 1.57699 9.427 2.16257 10 2.9254C10.573 2.16257 11.248 1.57699 12.025 1.16865C12.802 0.760319 13.627 0.556152 14.5 0.556152C15.9192 0.556152 17.1073 1.03465 18.0645 1.99165C19.0215 2.94882 19.5 4.13699 19.5 5.55615C19.5 6.27149 19.374 6.97657 19.122 7.6714C18.8702 8.3664 18.4272 9.13532 17.7932 9.97815C17.1592 10.8212 16.3018 11.7831 15.221 12.8639C14.1403 13.9446 12.7679 15.2368 11.1038 16.7407L10 17.7329Z" fill="white"/>
    </svg>
  `;

  /**
   * Get wishlist from localStorage
   */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem("wishlist")) || [];
    } catch (e) {
      console.error("Error reading wishlist:", e);
      return [];
    }
  }

  /**
   * Save wishlist to localStorage
   */
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    } catch (e) {
      console.error("Error saving wishlist:", e);
    }
  }

  /**
   * Update wishlist counter in header/navigation
   */
  function updateWishlistCounter() {
    const wishlist = getWishlist();
    const counters = document.querySelectorAll(".wishlist-counter");
    counters.forEach((counter) => {
      counter.textContent = wishlist.length;
      // Add/remove empty state class for styling
      if (wishlist.length === 0) {
        counter.classList.add("is-empty");
      } else {
        counter.classList.remove("is-empty");
      }
    });
  }

  /**
   * Update button UI based on wishlist state
   */
  function updateButtonState(btn, isInWishlist) {
    const icon = btn.querySelector(".wishlist-icon");
    const text = btn.querySelector(".wishlist-text");

    if (isInWishlist) {
      btn.classList.add("is-active");
      btn.setAttribute("aria-pressed", "true");
      if (icon) icon.innerHTML = HEART_FILLED;
      if (text) text.textContent = "Remove from Wishlist";
    } else {
      btn.classList.remove("is-active");
      btn.setAttribute("aria-pressed", "false");
      if (icon) icon.innerHTML = HEART_OUTLINE;
      if (text) text.textContent = "Add to Wishlist";
    }
  }

  /**
   * Load and apply wishlist state to all buttons on page
   */
  function loadWishlistState() {
    const wishlist = getWishlist();
    const wishlistIds = new Set(wishlist.map((item) => item.id));

    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const productId = btn.getAttribute("data-product-id");
      const isInWishlist = wishlistIds.has(productId);
      updateButtonState(btn, isInWishlist);
    });
  }

  /**
   * Show notification toast
   */
  function showNotification(message, type = "success") {
    // Remove any existing notifications
    const existing = document.querySelector(".wishlist-notification");
    if (existing) existing.remove();

    const notification = document.createElement("div");
    notification.className = `wishlist-notification wishlist-notification--${type}`;
    notification.setAttribute("role", "status");
    notification.setAttribute("aria-live", "polite");
    notification.textContent = message;

    document.body.appendChild(notification);

    // Trigger animation
    setTimeout(() => notification.classList.add("show"), 10);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.classList.remove("show");
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  /**
   * Add product to wishlist
   */
  function addToWishlist(btn) {
    const productId = btn.getAttribute("data-product-id");
    const productTitle = btn.getAttribute("data-product-title");
    const productImage = btn.getAttribute("data-product-image");
    const productPrice = btn.getAttribute("data-product-price");
    const productUrl = btn.getAttribute("data-product-url");

    const wishlist = getWishlist();

    // Check if already exists
    if (wishlist.some((item) => item.id === productId)) {
      return false;
    }

    // Add new item
    wishlist.push({
      id: productId,
      title: productTitle,
      image: productImage,
      price: productPrice,
      url: productUrl,
      addedAt: new Date().toISOString(),
    });

    saveWishlist(wishlist);
    updateButtonState(btn, true);
    updateWishlistCounter();
    showNotification(`Product Added To Wishlist`, "success");

    // Dispatch custom event for other scripts to listen to
    window.dispatchEvent(
      new CustomEvent("wishlist:added", {
        detail: { productId, productTitle },
      })
    );

    return true;
  }

  /**
   * Remove product from wishlist
   */
  function removeFromWishlist(btn) {
    const productId = btn.getAttribute("data-product-id");
    let wishlist = getWishlist();

    const removedItem = wishlist.find((item) => item.id === productId);
    if (!removedItem) {
      return false;
    }

    wishlist = wishlist.filter((item) => item.id !== productId);
    saveWishlist(wishlist);
    updateButtonState(btn, false);
    updateWishlistCounter();
    showNotification(`Product Removed From Wishlist`, "error");

    // Dispatch custom event
    window.dispatchEvent(
      new CustomEvent("wishlist:removed", {
        detail: { productId, productTitle: removedItem.title },
      })
    );

    return true;
  }

  /**
   * Toggle wishlist item
   */
  function toggleWishlist(btn) {
    const productId = btn.getAttribute("data-product-id");
    const wishlist = getWishlist();
    const isInWishlist = wishlist.some((item) => item.id === productId);

    if (isInWishlist) {
      removeFromWishlist(btn);
    } else {
      addToWishlist(btn);
    }
  }

  /**
   * Initialize wishlist buttons
   */
  function initWishlistButtons() {
    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      // Skip if already initialized
      if (btn.hasAttribute("data-wishlist-initialized")) {
        return;
      }

      // Mark as initialized
      btn.setAttribute("data-wishlist-initialized", "true");

      // Add accessibility attributes
      btn.setAttribute("type", "button");
      btn.setAttribute("aria-pressed", "false");
      btn.setAttribute("aria-label", "Add to wishlist");

      // Add click event
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(this);
      });
    });
  }

  // Initialize on page load
  initWishlistButtons();
  loadWishlistState();
  updateWishlistCounter();

  // Re-initialize when new content is loaded (for AJAX/dynamic content)
  if (typeof Shopify !== "undefined" && Shopify.theme) {
    document.addEventListener("shopify:section:load", function () {
      setTimeout(() => {
        initWishlistButtons();
        loadWishlistState();
      }, 100);
    });
  }

  // Watch for dynamically added wishlist buttons (recommended products, quick view, etc.)
  const observer = new MutationObserver(function (mutations) {
    let shouldReinit = false;
    
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        // Check if the added node contains wishlist buttons
        if (node.nodeType === 1) { // Element node
          if (
            node.classList?.contains("wishlist-btn") ||
            node.querySelector?.(".wishlist-btn")
          ) {
            shouldReinit = true;
          }
        }
      });
    });

    if (shouldReinit) {
      // Small delay to ensure DOM is fully updated
      setTimeout(() => {
        initWishlistButtons();
        loadWishlistState();
      }, 100);
    }
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Listen for common dynamic content events
  document.addEventListener("product:loaded", function () {
    initWishlistButtons();
    loadWishlistState();
  });

  document.addEventListener("variant:change", function () {
    initWishlistButtons();
    loadWishlistState();
  });

  // Handle Shopify AJAX cart events
  document.addEventListener("cart:updated", function () {
    initWishlistButtons();
    loadWishlistState();
  });

  // Handle theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:block:select", function () {
      setTimeout(() => {
        initWishlistButtons();
        loadWishlistState();
      }, 100);
    });

    document.addEventListener("shopify:block:deselect", function () {
      setTimeout(() => {
        initWishlistButtons();
        loadWishlistState();
      }, 100);
    });
  }

  // Handle window load event (catches everything that loads after DOMContentLoaded)
  window.addEventListener("load", function () {
    setTimeout(() => {
      initWishlistButtons();
      loadWishlistState();
    }, 500);
  });

  // Expose functions globally for external use
  window.Wishlist = {
    add: function (productId) {
      const btn = document.querySelector(
        `.wishlist-btn[data-product-id="${productId}"]`
      );
      if (btn) addToWishlist(btn);
    },
    remove: function (productId) {
      const btn = document.querySelector(
        `.wishlist-btn[data-product-id="${productId}"]`
      );
      if (btn) removeFromWishlist(btn);
    },
    toggle: function (productId) {
      const btn = document.querySelector(
        `.wishlist-btn[data-product-id="${productId}"]`
      );
      if (btn) toggleWishlist(btn);
    },
    getAll: getWishlist,
    clear: function () {
      localStorage.removeItem("wishlist");
      loadWishlistState();
      updateWishlistCounter();
    },
    getCount: function () {
      return getWishlist().length;
    },
  };

  // Expose reinit function globally for manual triggering
  window.Wishlist.reinit = function () {
    initWishlistButtons();
    loadWishlistState();
  };
});